var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      key: "referral-history-modal-" + Math.random(),
      staticClass: "referral-credits-history",
      attrs: {
        "dark-background": true,
        large: true,
        "no-border-radius": true,
        "show-close-button": true,
        scrollable: true,
        "should-manage-scroll-lock": false
      },
      on: { close: _vm.bubbleClose }
    },
    [
      _vm.loading
        ? _c("LoadingAnimation")
        : [
            _c("h1", [_vm._v("People you've referred")]),
            _vm._v(" "),
            _c("p", { staticClass: "lead" }, [
              _vm._v(
                "The credit you earn can be used toward your next annual Premium payment."
              )
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Pending")]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "unstyled pending" },
              [
                _vm._l(_vm.pendingReferrals, function(pendingReferral) {
                  return _c("li", [
                    _c("p", [_vm._v(_vm._s(pendingReferral.email))])
                  ])
                }),
                _vm._v(" "),
                !_vm.pendingReferrals.length
                  ? _c("li", [_c("p", [_vm._v("No pending referrals yet.")])])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h3", [_vm._v("Past referrals")]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "unstyled past-referrals" },
              [
                _vm._l(_vm.pastReferrals, function(pastReferral) {
                  return _c("li", [
                    _c("p", [_vm._v(_vm._s(pastReferral.email))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "credit" }, [
                      _vm._v(
                        "+$" +
                          _vm._s(_vm.toDollarAmount(pastReferral.free_months))
                      )
                    ])
                  ])
                }),
                _vm._v(" "),
                !_vm.pastReferrals.length
                  ? _c("li", [_c("p", [_vm._v("No past referrals yet.")])])
                  : _vm._e()
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }